import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)

const opts = {
  theme: {
    themes: {
      light: {
        primary: '#880016',
        secondary: '#C18E37',
      },
    },
  },
};

export default new Vuetify(opts)
